import Head from "next/head";
import Footer from "pages/components/Footer";
import StartHumming from "pages/components/StartHumming";
import Topbar from "pages/components/Topbar";
import React from "react";
import { ExtendedNextPage } from "types/pages";

import Content from "components/Content";
import Label from "components/Label";
import styles from "./styles.module.scss";
import { privacy } from "./constants";

const Privacy: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Privacy policy</title>
        <meta
          name="our-privacy-policy"
          content="Humming home's privacy policy"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Content contentClassName={styles.terms}>
        <Label className={styles.title} variant="h2-centered" color="primary">
          Privacy Policy
        </Label>
        <Label color="primary" useMarkdown>
          {privacy}
        </Label>
      </Content>
      <StartHumming fillColor="primary" />
    </div>
  );
};

Privacy.getLayout = (page) => {
  return (
    <div>
      <Topbar withHeader />
      {page}
      <Footer />
    </div>
  );
};

export default Privacy;
